module.exports = __webpack_public_path__ + "img/banner-contact-desk-min.73000780.jpg";